import { render, staticRenderFns } from "./ViewBlogBody.vue?vue&type=template&id=2f8439e5&"
import script from "./ViewBlogBody.vue?vue&type=script&lang=js&"
export * from "./ViewBlogBody.vue?vue&type=script&lang=js&"
import style0 from "./ViewBlogBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports